import { WebPlugin } from '@capacitor/core';
export class WechatHKWeb extends WebPlugin {
    async echo(options) {
        console.log('ECHO', options);
        return options;
    }
    async makePaymentRequest(options) {
        console.warn('web not implemented', options);
        return {};
    }
}
//# sourceMappingURL=web.js.map